import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import React, { useCallback } from "react";
import { useEffect } from "react";
import { useState } from "react";
import AddKinForm from "./AddKinForm";
import { grey } from "@mui/material/colors";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";
import EditKinForm from "./EditKinForm";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteKinForm from "./DeleteKinForm";
import FetchHook from "../../../../Api/FetchHooks";
import AlertComponent from "../../../../Components/AlertComponent";
import { useLocation } from "react-router-dom";
import ActionDialog from "../../../../Components/ActionDialog";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import { getFullName } from "../../../../utils/helpers";
import { useSelector } from "react-redux";
import ErrorDisplay from "../../../../Components/ErrorDisplay";
import { AllInbox } from "@mui/icons-material";

const options = [
  "None",
  "Atria",
  "Callisto",
  "Dione",
  "Ganymede",
  "Hangouts Call",
  "Luna",
  "Oberon",
  "Phobos",
  "Pyxis",
  "Sedna",
  "Titania",
  "Triton",
  "Umbriel",
];

const ITEM_HEIGHT = 48;

const KinInfo = ({ _user }) => {
  const location = useLocation();
  const loggedInUser = useSelector((state) => state.auth.user);

  const [dialog, setDialog] = useState({
    open: false,
    type: null,
    label: null,
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const [user, setUser] = useState(
    _user || location.state?.user || loggedInUser
  );
  const [kins, setKins] = useState([]);
  const [kin, setKin] = useState();

  const openDialog = (type, label) => setDialog({ open: true, type, label });
  const closeDialog = () => setDialog({ open: false, type: null, label: null });

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const [loading, kinResponse, kinRequest] = FetchHook();

  const fetchData = useCallback(async () => {
    await kinRequest({
      url: `/next_kin?member_entity_id=${user?.id}&status=active`,
    });
  }, [user]);

  useEffect(() => {
    fetchData();
  }, [user]);

  useEffect(() => {
    if (kinResponse && kinResponse.status === 200) {
      setKins(kinResponse.data.Data);
    }
  }, [kinResponse]);

  return (
    <>
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      <ActionDialog
        open={dialog.open}
        onClose={closeDialog}
        dialogType={dialog.type}
        dialogLabel={dialog.label}
        user={user}
        data={kin}
        onSuccess={fetchData}
      />

      <Card>
        <CardHeader
          title={
            <Typography variant="subtitle1">
              Kin / Beneficiary Information
            </Typography>
          }
          action={
            <>
              {/* <Button
                variant="contained"
                color="primary"
                onClick={() =>
                  openDialog(
                    "add_kin",
                    "Add next of kin/beneficiary formAdd next of kin/beneficiary form"
                  )
                }
              >
                Add kin
              </Button> */}
              <IconButton
                onClick={() =>
                  openDialog("add_kin", "Add next of kin/beneficiary form")
                }
              >
                <PersonAddIcon />
              </IconButton>
            </>
          }
        />

        <Divider sx={{ my: 1 }} />

        <CardContent>
          {loading ? (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <CircularProgress />
            </Box>
          ) : kins.length > 0 ? (
            <Grid container spacing={2}>
              {kins.map((el, i) => (
                <Grid item xs={12}>
                  <Card mb={2} key={i}>
                    <CardHeader
                      action={
                        <>
                          <IconButton
                            aria-label="edit"
                            onClick={() => {
                              setKin(el);
                              openDialog(
                                "edit_kin",
                                "Edit next of kin/beneficiary"
                              );
                            }}
                          >
                            <EditIcon />
                          </IconButton>
                          <IconButton
                            aria-label="delete"
                            color="error"
                            onClick={() => {
                              setKin(el);
                              openDialog(
                                "delete_kin",
                                "Delete next of kin/beneficiary"
                              );
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </>
                      }
                      title={
                        <>
                          <Typography
                            style={{
                              textTransform: "capitalize",
                              // marginRight: ".5rem",
                            }}
                            variant="body2"
                            fontWeight={"medium"}
                          >
                            Name: {getFullName(el)}
                          </Typography>

                          <Typography variant="subtitle2">
                            Allocation (%): {`${el?.allocation}`}
                          </Typography>
                        </>
                      }
                    />
                  </Card>
                </Grid>
              ))}
            </Grid>
          ) : (
            <ErrorDisplay
              message="No next of kin/beneficiary found!"
              icon={
                <AllInbox color="secondary" sx={{ mx: "auto", fontSize: 80 }} />
              }
            />
          )}
        </CardContent>
      </Card>
    </>
  );
};

export default KinInfo;
